import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import useEditorOptionsList from '@/modules/corporate/modules/questions/fields/hooks/useEditorOptionsList';
import { QuestionEditorProps } from '@/modules/corporate/modules/questions/fields/types';

import EditorOptionsListItem from './components/EditorOptionsListItem';
import ImagePlaceholder from './components/EditorOptionsListItem/ImagePlaceholder';
import { imageStyles } from './styles';

const EditorOptionsList = (props: QuestionEditorProps) => {
  const { t } = useTranslation();
  const { viewMode, className } = props;
  const { options, onAction, onAddOption } = useEditorOptionsList(props);

  return (
    <Stack className={cn('flex-wrap', className)} direction="row" justifyContent="between">
      {options.map((option, index) => (
        <EditorOptionsListItem
          key={`optionItem_${index}`}
          index={index}
          option={option}
          viewMode={viewMode}
          onAction={onAction}
        />
      ))}
      {viewMode !== 'create' ? null : (
        <Stack className="mb-32" direction="col">
          <ImagePlaceholder className={imageStyles} onClick={onAddOption} />
          <AddBlock
            className="mt-8 flex-1 px-12 py-8"
            title={t('QuizCreator:AddOption')}
            onClick={onAddOption}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default EditorOptionsList;
